import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function EmptyFeed({ liveCount }) {
  const { t } = useTranslation();
  return (
    <div className="rounded-3xl border border-white/5 bg-black/40 p-6 text-center" data-testid="vibe-feed-empty">
      {liveCount > 0 ? (
        <>
          <p className="text-zinc-300 leading-relaxed">
            {t("feed.emptyWithDensity")}
          </p>
          <Link
            to="/scan-nearby"
            data-testid="empty-goto-nearby"
            className="mt-4 inline-flex items-center gap-2 px-5 py-2.5 rounded-full border border-[#E60000] text-[#E60000] hover:bg-[#E60000] hover:text-white font-bold text-sm transition"
          >
            {t("feed.openScanNearby")}
          </Link>
        </>
      ) : (
        <>
          <p className="text-zinc-400 text-sm">{t("feed.emptyNoDensity")}</p>
          <p className="text-zinc-600 text-xs mt-2 font-mono-accent tracking-widest">{t("feed.densityMagic")}</p>
        </>
      )}
    </div>
  );
}
